import { Command } from 'commander';
import { getV2Client } from '../../api/v2-client.js';
import type { IV2Client } from '../../api/v2-client.js';
import { handleV2Error } from '../../handle-error.js';
import { Output } from '../../output.js';
import { resolveSpaceIdBySlug } from './show.js';

interface MembersOpts { json?: boolean; org?: string; }

export async function runSpaceMembers(slug: string, opts: MembersOpts, client?: IV2Client): Promise<void> {
  const out = Output.fromOpts({ json: !!opts.json, quiet: false });
  const c = client ?? await getV2Client(opts.org ?? undefined);
  const id = await resolveSpaceIdBySlug(c, slug);
  const resp = await c.get<{ members: Array<{ name: string; slug: string; email: string; role: string }> }>(`/api/v2/spaces/${id}/members`);
  out.json(() => resp.members);
  out.human(() => {
    if (resp.members.length === 0) return 'No members.';
    return resp.members.map((m) => `  - ${m.name} (${m.slug}) — ${m.email} — ${m.role}`).join('\n');
  });
}

export const spaceMembersCommand = new Command('members')
  .description('List space members')
  .argument('<slug>', 'Space slug')
  .option('--json', 'JSON output')
  .option('--org <slug>', 'Override active grid')
  .action(async (slug: string, opts: MembersOpts) => {
    try { await runSpaceMembers(slug, opts); }
    catch (err) { await handleV2Error(err, { json: !!opts.json }); }
  });
